import { AppTooltip } from '@components/ui/tooltip/tooltip';
import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover';
import { useMediaQuery } from '@hooks/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { JobStatus } from '../helpers';
import { Alert } from '@root/globalTypes';
import { icons } from '../stage/constants';
import { JobAlertTooltip } from './tooltip';

interface JobAlertProps {
  status: JobStatus;
  alerts: Alert[];
}

export const JobAlert = ({ status, alerts }: JobAlertProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'pages.job' });
  const isTouch = useMediaQuery('(hover: none)');

  if (!['error', 'warning'].includes(status)) return <span>{icons[status]}</span>;

  if (isTouch)
    return (
      <span className="contents" onClick={(e) => e.stopPropagation()}>
        <Popover>
          <PopoverTrigger asChild>
            <button
              type="button"
              aria-label={t('alertsTitle')}
              className="-m-2.5 flex h-11 w-11 shrink-0 items-center justify-center">
              {icons[status]}
            </button>
          </PopoverTrigger>
          <PopoverContent
            align="start"
            className="w-auto max-w-[calc(100vw-32px)] p-3 text-neutral-800 shadow-stage-menu">
            <JobAlertTooltip data={alerts} wrap />
          </PopoverContent>
        </Popover>
      </span>
    );

  return (
    <AppTooltip context={<JobAlertTooltip data={alerts} />}>
      <span>{icons[status]}</span>
    </AppTooltip>
  );
};
